import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1ZM13 9.5V14.5C13 16.433 11.433 18 9.5 18C7.567 18 6 16.433 6 14.5C6 12.8056 7.20308 11.3944 8.80107 11.07L9.78108 10.8711L10.1789 12.8311L9.19893 13.03C8.51468 13.1689 8 13.7755 8 14.5C8 15.3284 8.67157 16 9.5 16C10.3284 16 11 15.3284 11 14.5V9.5C11 7.567 12.567 6 14.5 6C16.433 6 18 7.567 18 9.5C18 11.1944 16.7969 12.6056 15.1989 12.93L14.2189 13.1289L13.8211 11.1689L14.8011 10.97C15.4853 10.8311 16 10.2245 16 9.5C16 8.67157 15.3284 8 14.5 8C13.6716 8 13 8.67157 13 9.5Z"}}]};

const LogoMiniprogramFilled = Vue.extend<IconProps>({
  name: 'LogoMiniprogramFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'logo-miniprogram-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default LogoMiniprogramFilled;
